
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sample-search",
      function () {
        return require("private-next-pages/sample-search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sample-search"])
      });
    }
  